export default __webpack_public_path__ + "static/media/eyclick-logo.75fec775.svg";